export const environment = {
    envName: 'dev',
    production: false,
    calConfigPath: 'assets/config.dev.json',
    clientId: 'ac406b7d-72c2-4bea-92f9-bbee126af710',
    // audience: 'https://olop-test.azure.chevron.com',
    hostApiURL: 'https://olop-dev-cvx.azurewebsites.net/',
    apiScope: '7b76eddb-dbbd-4ce1-b3c8-340c42e03fac/user_impersonation',
};
